import { EMAIL_REGEX } from '@shared/dream-components/utils/emailRegex';

function isValidEmail(email: string) {
  return EMAIL_REGEX.test(email);
}

export default isValidEmail;
